import React from 'react'
import { InfoIcon as BaseInfoIcon } from '@chilecompra/react-kit/components'
import { ButtonBase, Grid as BaseGrid, Link as LinkBase, styled } from '@mui/material'
import { InsertDriveFile } from '@mui/icons-material'

export const Box = styled('div')`
  display: flex;
  width: ${props => props.width || '100%'};
`

export const Column = styled(({ margin, padding, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
    width: ${props => props.width};
  }
`

export const DownloadButton = styled(ButtonBase)`
  &.MuiButtonBase-root {
    color: ${props => props.theme.palette.blue[50]};
    padding: 0;
  }

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const FileIcon = styled(InsertDriveFile)`
  color: currentColor;
  font-size: 1.6rem;
`

export const InfoIcon = styled(BaseInfoIcon)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.gray[50]};
    height: 0.7em;
    margin: 0 8px 0 0;
  }
`

export const Link = styled(LinkBase)`
  &.MuiTypography-root {
    color: ${props => props.theme.palette.blue[50]};
    font-size: 14px;
  }
`

export const Loading = styled('div')`
  align-items: center;
  color: ${props => props.theme.palette.blue[50]};
  display: flex;
  justify-content: center;
  width: 100%;
`

export const Row = styled(({ margin, ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0 -5px'};
    padding: 12px 0 0;
    width: 100%;
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`
